import { useTranslation } from 'react-i18next'

import { MenuIcon } from '@pleio/icons/menu'

import { openDrawer } from 'js/components/Drawer'
import { Container } from 'js/components/Grid'
import NavigationMenu from 'js/components/NavigationMenu/NavigationMenu'
import { Show } from 'js/components/Show'
import Sticky from 'js/components/Sticky/Sticky'
import MobileNavigation, {
    MOBILE_NAVIGATION_ID,
} from 'js/layout/MobileNavigation/MobileNavigation'
import NavigationAction from 'js/layout/Navigation/components/NavigationAction'
import NavigationTools from 'js/layout/Navigation/components/NavigationTools'

import styles from './Navigation.module.css'

const Navigation = ({ site, viewer }) => {
    const { t } = useTranslation()

    if (!site) {
        return null
    }

    const isCompact = site.menuState === 'compact'

    const menuButton = (
        <NavigationAction
            tooltip={t('action.show-navigation')}
            aria-controls={MOBILE_NAVIGATION_ID}
            aria-haspopup="dialog"
            onClick={() => openDrawer(MOBILE_NAVIGATION_ID)}
            style={{ marginLeft: '-8px' }}
        >
            <MenuIcon />
        </NavigationAction>
    )

    return (
        <>
            <Sticky className={styles.wrapper}>
                <Container>
                    <div className={styles.bar}>
                        {/* The compact menu always uses the drawer, the full menu only below desktop */}
                        {isCompact ? (
                            menuButton
                        ) : (
                            <Show until="desktop">{menuButton}</Show>
                        )}
                        {!isCompact && (
                            <Show from="desktop">
                                <NavigationMenu site={site} />
                            </Show>
                        )}
                        <NavigationTools site={site} viewer={viewer} />
                    </div>
                </Container>
            </Sticky>
            <MobileNavigation site={site} />
        </>
    )
}

export default Navigation
